import { RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [
  {
    path: "",
    title: "Tableau de bord",
    moduleName: "dashboard",
    iconType: "home",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "TABLEAU_DE_BORD",
    submenu: [
      {
        path: "dashboard/admin",
        title: "Admin",
        moduleName: "dashboard",
        iconType: "th-large",
        icon: "description",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "TABLEAU_DE_BORD_ADMIN",
        submenu: [],
      },
      {
        path: "dashboard/general",
        title: "Général",
        moduleName: "dashboard",
        iconType: "bar-chart",
        icon: "description",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "TABLEAU_DE_BORD_GENERAL",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Paramètres",
    moduleName: "parametres",
    iconType: "cogs",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "PARAMETRES",
    submenu: [
      {
        path: "",
        title: "Système",
        moduleName: "systeme",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PARAM_SYSTEME",
        submenu: [
          {
            path: "/parametres/systeme/global",
            title: "Global",
            moduleName: "systeme-global",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PARAM_SYSTEME_GLOBAL",
            submenu: [],
          },
          {
            path: "/parametres/systeme/circuit-validation",
            title: "Circuit de validation",
            moduleName: "systeme-circuit-validation",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PARAM_SYSTEME_CIRCUIT_VALIDATION",
            submenu: [],
          },
          {
            path: "/parametres/systeme/messages",
            title: "Messages",
            moduleName: "systeme-messages",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PARAM_SYSTEME_MESSAGES",
            submenu: [],
          },
        ],
      },
      {
        path: "/parametres/divers",
        title: "Divers",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PARAM_DIVERS",
        submenu: [],
      },
      {
        path: "",
        title: "Production",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PARAM_PRODUCTION",
        submenu: [
          {
            path: "/parametres/production/de-base",
            title: "Paramètre de base",
            moduleName: "production",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PARAM_PRODUCTION_DE_BASE",
            submenu: [],
          },
          {
            path: "/parametres/production/avances",
            title: "Paramètre avancé",
            moduleName: "production",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PARAM_PRODUCTION_AVANCES",
            submenu: [],
          },
        ],
      },
      {
        path: "/parametres/medical",
        title: "Médical",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PARAM_MEDICAL",
        submenu: [],
      },
      {
        path: "/parametres/sinistre",
        title: "Sinistre",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PARAM_SINISTRE",
        submenu: [],
      },
      {
        path: "/parametres/comptabilite",
        title: "Comptabilité",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PARAM_COMPTABILITE",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Production",
    moduleName: "production",
    iconType: "briefcase",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "PRODUCTION",
    submenu: [
      {
        path: "/production/contrat",
        title: "Contrat",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PRODUCTION_CONTRAT",
        submenu: [],
      },
      {
        path: "/production/info-beneficiaire",
        title: "Info bénéficiaire",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PRODUCTION_INFO_BENEFICIAIRE",
        submenu: [],
      },
      {
        path: "",
        title: "Quittance",
        moduleName: "quittance",
        iconType: "",
        icon: "",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PRODUCTION_QUITTANCE",
        submenu: [
          {
            path: "/production/quittance/emission",
            title: "Emettre quittance",
            moduleName: "quittance-emission",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRODUCTION_QUITTANCE_EMISSION",
            submenu: [],
          },
          {
            path: "/production/quittance/historique",
            title: "Quittances émises",
            moduleName: "quittance-historique",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRODUCTION_QUITTANCE_HISTORIQUE",
            submenu: [],
          },
        ],
      },
      {
        path: "",
        title: "Facturation",
        moduleName: "facturation",
        iconType: "",
        icon: "",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PRODUCTION_FACTURATION",
        submenu: [
          {
            path: "/production/facturation/facturer-garant",
            title: "Facturer garant",
            moduleName: "facturer-garant",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRODUCTION_FACTURER_GARANT",
            submenu: [],
          },
          {
            path: "/production/facturation/facturer-police",
            title: "Facturer police",
            moduleName: "facturer-police",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRODUCTION_FACTURER_POLICE",
            submenu: [],
          },
        ],
      },
      {
        path: "/production/avenants",
        title: "Avenants",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PRODUCTION_AVENANTS",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Prestation",
    moduleName: "prestation",
    iconType: "medkit",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "PRESTATION",
    submenu: [
      {
        path: "/prestation/tiers-payant",
        title: "Tiers payant",
        moduleName: "prestation",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PRESTATION_TIERS_PAYANT",
        submenu: [],
      },
      {
        path: "",
        title: "Saisie RD",
        moduleName: "saisie-rd",
        iconType: "",
        icon: "",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "PRESTATION_SAISIE_RD",
        submenu: [
          {
            path: "/prestation/saisie-rd/consultation",
            title: "Consultation",
            moduleName: "consultation",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_CONSULTATION",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/ordonnance",
            title: "Ordonnance",
            moduleName: "ordonnance",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_ORDONNANCE",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/pharmacie",
            title: "Pharmacie",
            moduleName: "pharmacie",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_PHARMACIE",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/hospitalisation",
            title: "Hospitalisation",
            moduleName: "hospitalisation",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_HOSPIT",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/laboratoire",
            title: "Laboratoire",
            moduleName: "laboratoire",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_LABO",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/imagerie",
            title: "Imagerie",
            moduleName: "imagerie",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_IMAGERIE",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/optique",
            title: "Optique",
            moduleName: "optique",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_OPTIQUE",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/dentisterie",
            title: "Dentaire",
            moduleName: "dentisterie",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_DENTISTERIE",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/maternite",
            title: "Maternité",
            moduleName: "maternite",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_MATERNITE",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/transport",
            title: "Transport médicalisé",
            moduleName: "transport",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_TRANSPORT",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/procrea",
            title: "Procréa",
            moduleName: "procrea",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_PROCREA",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/bilan",
            title: "Bilan",
            moduleName: "bilan",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_BILAN",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/kine",
            title: "Kinésithérapie",
            moduleName: "kine",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_KINE",
            submenu: [],
          },
          {
            path: "/prestation/saisie-rd/auxiliaire",
            title: "Auxiliaire médical",
            moduleName: "auxiliaire",
            iconType: "",
            icon: "",
            class: "ml-menu2",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "PRESTATION_SAISIE_RD_AUXILIAIRE",
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    path: "",
    title: "Médical",
    moduleName: "medical",
    iconType: "heartbeat",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "MEDICAL",
    submenu: [
      {
        path: "/medical/entente-prealable",
        title: "Entente préalable",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "MEDICAL_ENTENTE_PREALABLE",
        submenu: [],
      },
      {
        path: "/medical/renouvellement-bon-medicament",
        title: "Renouvellement bon",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "MEDICAL_RENOUVELLEMENT_BON",
        submenu: [],
      },
      {
        path: "/medical/visite-hospitalisation",
        title: "Visite hospitalisation",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "MEDICAL_VISITE_HOSPITALISATION",
        submenu: [],
      },
      {
        path: "/medical/traitement-rd",
        title: "Traitement RD",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "MEDICAL_TRAITEMENT_RD",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Sinistre",
    moduleName: "sinistre",
    iconType: "exclamation-triangle",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "SINISTRE",
    submenu: [
      {
        path: "/sinistre/decompte",
        title: "Décompte",
        moduleName: "sinistre",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "SINISTRE_DECOMPTE",
        submenu: [],
      },
      {
        path: "/sinistre/validation-decompte",
        title: "Validation décompte",
        moduleName: "sinistre",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "SINISTRE_VALIDATION_DECOMPTE",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Comptabilité",
    moduleName: "comptabilite",
    iconType: "calculator",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "COMPTABILITE",
    submenu: [
      {
        path: "/comptabilite/validation-compta",
        title: "Validation compta",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "COMPTABILITE_VALIDATION_COMPTA",
        submenu: [],
      },
      {
        path: "/comptabilite/reglement-facture",
        title: "Règlement factures",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "COMPTA_REGLEMENT_FACTURE",
        submenu: [],
      },
      {
        path: "",
        title: "Encaissement",
        moduleName: "encaissement",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "COMPTABILITE_ENCAISSEMENT",
        submenu: [
          {
            path: "/comptabilite/encaissement/encaisser-facture",
            title: "Encaisser garant",
            moduleName: "encaisser-facture",
            iconType: "",
            icon: "",
            class: "",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "COMPTABILITE_ENCAISSER_FACTURE",
            submenu: [],
          },
          {
            path: "/comptabilite/encaissement/encaissement-souscripteur",
            title: "Encaisser quittance",
            moduleName: "encaissement-souscripteur",
            iconType: "",
            icon: "",
            class: "",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "COMPTABILITE_ENCAISSEMENT_SOUSCRIPTEUR",
            submenu: [],
          },
          {
            path: "/comptabilite/encaissement/encaisser-police",
            title: "Encaisser police",
            moduleName: "encaisser-police",
            iconType: "",
            icon: "",
            class: "",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "COMPTABILITE_ENCAISSER_POLICE",
            submenu: [],
          },
        ],
      },
      {
        path: "/comptabilite/banlance-agee",
        title: "Balance agée",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "COMPTABILITE_BALANCE_AGEE",
        submenu: [],
      },

      {
        path: "",
        title: "Compte partenaire",
        moduleName: "compte-partenaire",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "COMPTABILITE_COMPTE_PARTENAIRE",
        submenu: [
          {
            path: "/comptabilite/compte-partenaire/compte-garant",
            title: "Compte garant",
            moduleName: "compte-garant",
            iconType: "",
            icon: "",
            class: "",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "COMPTABILITE_COMPTE_GARANT",
            submenu: [],
          },
          {
            path: "/comptabilite/compte-partenaire/compte-police",
            title: "Compte police",
            moduleName: "compte-police",
            iconType: "",
            icon: "",
            class: "",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "COMPTABILITE_COMPTE_POLICE",
            submenu: [],
          },
          {
            path: "/comptabilite/compte-partenaire/compte-souscripteur",
            title: "Compte souscripteur",
            moduleName: "compte-souscripteur",
            iconType: "",
            icon: "",
            class: "",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            codification: "COMPTABILITE_COMPTE_SOUSCRIPTEUR",
            submenu: [],
          },
        ],
      },
      {
        path: "/comptabilite/deversement",
        title: "Déversement",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "COMPTABILITE_DEVERSEMENT",
        submenu: [],
      },
      {
        path: "/comptabilite/etat-compta",
        title: "Etat de la compta",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "COMPTABILITE_ETAT_COMPTA",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Administration",
    moduleName: "administration",
    iconType: "users",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "ADMINISTRATION",
    submenu: [
      {
        path: "/administration/utilisateurs",
        title: "Utilisateurs",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "ADMINISTRATION_UTILISATEURS",
        submenu: [],
      },
      {
        path: "/administration/roles",
        title: "Roles",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "ADMINISTRATION_ROLES",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-prestataires",
        title: "Utilisateurs prestataires",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "ADMINISTRATION_UTILISATEURS_PRESTATAIRES",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-garants",
        title: "Utilisateurs garants",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "ADMINISTRATION_UTILISATEURS_GARANTS",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-beneficiaire",
        title: "Utilisateurs beneficiaire",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "ADMINISTRATION_UTILISATEURS_BENEFICIAIRES",
        submenu: [],
      },
      {
        path: "/administration/notifications",
        title: "Notifications",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "ADMINISTRATION_NOTIFICATIONS",
        submenu: [],
      },
      {
        path: "/administration/etapes-validation",
        title: "Étapes de validation",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "ADMINISTRATION_ETAPES_VALIDATION",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Audit",
    moduleName: "audit",
    iconType: "history",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "AUDIT",
    submenu: [
      {
        path: "/audit/historique-connexion",
        title: "Historique connexion",
        moduleName: "audit",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "AUDIT_HISTORIQUE_CONNEXION",
        submenu: [],
      },
      {
        path: "/audit/historique-navigation",
        title: "Historique navigation",
        moduleName: "audit",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "AUDIT_HISTORIQUE_NAVIGATION",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Edititque",
    moduleName: "editique",
    iconType: "print",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "EDITIQUE",
    submenu: [
      {
        path: "/editique/recap-compagnie",
        title: "Récapitulatif compagnie",
        moduleName: "editique",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "EDITIQUE_RECAP_COMPAGNIE",
        submenu: [],
      },
      {
        path: "/editique/resultats-techniques",
        title: "Résultats techniques",
        moduleName: "editique",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "EDITIQUE_RESULTATS_TECHNIQUES",
        submenu: [],
      },
      {
        path: "/editique/fiche-prime",
        title: "Fiche prime",
        moduleName: "editique",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "EDITIQUE_FICHE_PRIME",
        submenu: [],
      },
      {
        path: "/editique/etat-depenses",
        title: "Etats des dépenses",
        moduleName: "editique",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "EDITIQUE_ETAT_DEPENSES",
        submenu: [],
      },
      {
        path: "/editique/historique",
        title: "Historique éditions",
        moduleName: "editique",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        codification: "EDITIQUE_HISTORIQUE",
        submenu: [],
      },
    ],
  },
  {
    title: "Ged",
    moduleName: "ged",
    iconType: "lock",
    icon: "description",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "GED",
    path: "/ged",
    submenu: [],
  },
  {
    title: "Manuel d'utilisation",
    moduleName: "manuel-utilisation",
    iconType: "book",
    icon: "description",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    codification: "",
    path: "/manuel-utilisation",
    submenu: [],
  },
];
